import { css } from 'styled-components';

import {
  WEBCHAT_LAUNCHER_CLEARANCE,
  WEBCHAT_LAUNCHER_LAYOUT,
} from '../constants/launcher';

type TClearanceProperty = 'bottom' | 'padding-right';

/**
 * Afasta um elemento fixo do canto inferior direito o bastante para ele não
 * ficar embaixo do launcher do chat (o nosso ou o da Callbell). Use quando
 * useWebchat().isLauncherVisible for true. upTo limita a regra às larguras em
 * que o elemento é fixo.
 */
export default function clearWebchatLauncher(
  property: TClearanceProperty,
  upTo?: string,
) {
  const mobileRule = css`
    ${property}: ${WEBCHAT_LAUNCHER_CLEARANCE.mobile};
  `;
  const upToQuery = upTo ? ` and (max-width: ${upTo})` : '';

  return css`
    ${upTo
      ? css`
          @media (max-width: ${upTo}) {
            ${mobileRule}
          }
        `
      : mobileRule}

    @media (min-width: ${WEBCHAT_LAUNCHER_LAYOUT.tabletBreakpoint})${upToQuery} {
      ${property}: ${WEBCHAT_LAUNCHER_CLEARANCE.tablet};
    }
  `;
}
